module.exports = __webpack_public_path__ + "static/media/event_slide_2.a6b2085c.png";